"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
class AnalyticsService {
    constructor(kvStore, rng, privilegedOrigins) {
        this.kvStore = kvStore;
        this.rng = rng;
        this.privilegedOrigins = privilegedOrigins;
        this.analyticsId = "";
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const saved = yield this.kvStore.get("analyticsId");
            if (saved) {
                this.analyticsId = saved;
                return;
            }
            const bytes = new Uint8Array(20);
            const rand = Array.from(yield this.rng(bytes))
                .map((value) => {
                let v = value.toString(16);
                if (v.length === 1) {
                    v = "0" + v;
                }
                return v;
            })
                .join("");
            this.analyticsId = rand;
            yield this.kvStore.set("analyticsId", rand);
        });
    }
    getAnalyticsIdOnlyIfPrivileged(env, origin) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!env.isInternalMsg && !this.privilegedOrigins.includes(origin)) {
                throw new Error("Rejected");
            }
            return this.analyticsId;
        });
    }
}
exports.AnalyticsService = AnalyticsService;
//# sourceMappingURL=service.js.map